import { Role } from '@/routes/PrivateRoute';
import useAuth from '@/hooks/useAuth';

// V2 Order Flow is enabled for all tenant admins, plus customer admins of
// allowlisted accounts. Add a customer id to expand per-client access.
const ORDER_FLOW_V2_ALLOWED_CUSTOMER_IDS = new Set([
  '836', // Avila Golf & Country Club
]);

const useOrderFlowV2Enabled = (): boolean => {
  const { currentAdmin, isCurrentCustomerAdmin } = useAuth();
  if (!currentAdmin) return false;
  // Tenant admins always get V2.
  if (currentAdmin.role === Role.TENANT_ADMIN) return true;
  // Customer admins: only allowlisted accounts.
  if (isCurrentCustomerAdmin(currentAdmin)) {
    return ORDER_FLOW_V2_ALLOWED_CUSTOMER_IDS.has(currentAdmin.customer.id);
  }
  return false;
};

export default useOrderFlowV2Enabled;
